import { useParams, Navigate } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { articles } from "../i18n/articles";
import { ASSETS } from "../i18n/content";
import ContentPage from "../components/ContentPage";

export default function Article() {
  const { slug } = useParams();
  const { lang } = useLanguage();
  const art = articles[slug];
  if (!art) return <Navigate to="/approfondimenti" replace />;
  const hero = art.heroImage.startsWith("stock:")
    ? ASSETS[art.heroImage.split(":")[1]]
    : art.heroImage;
  return <ContentPage content={art[lang]} heroImage={hero} />;
}
